import { Controller } from "@hotwired/stimulus";

// Polls the onboarding provision-progress endpoint and swaps this element in
// place with the freshly rendered partial. Deliberately never reloads the
// page — a full reload wipes any file the user has selected in the upload
// form on the same page while a provision job is running.
//
// The endpoint returns this same partial (wrapper included), so replacing
// outerHTML reconnects a fresh controller instance; polling continues while
// the server still reports an active run and stops on complete/failed.
export default class extends Controller {
  static values = {
    url: String,
    active: { type: Boolean, default: false },
  };

  connect() {
    if (!this.activeValue) return;
    this._timer = setTimeout(() => this.poll(), 5000);
  }

  disconnect() {
    if (this._timer) clearTimeout(this._timer);
  }

  async poll() {
    try {
      const response = await fetch(this.urlValue, {
        headers: { "Accept": "text/html" },
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const html = await response.text();
      this.element.outerHTML = html;
    } catch {
      this._timer = setTimeout(() => this.poll(), 10000);
    }
  }
}
